import { render, staticRenderFns } from "./JdsBreakdownHeading.vue?vue&type=template&id=f19c8744&scoped=true&"
import script from "./JdsBreakdownHeading.vue?vue&type=script&lang=ts&"
export * from "./JdsBreakdownHeading.vue?vue&type=script&lang=ts&"
import style0 from "./JdsBreakdownHeading.vue?vue&type=style&index=0&id=f19c8744&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f19c8744",
  null
  
)

export default component.exports